import Button from "@components/atoms/Button";
import styles from "./NavigationTab.module.scss";

interface NavigationTabProps {
  id: string;
  label: string;
  isActive: boolean;
  onClick: () => void;
}

export const NavigationTab = ({
  id,
  label,
  isActive,
  onClick,
}: NavigationTabProps) => {
  return (
    <Button
      onClick={onClick}
      className={`${styles["navigation-tab"]} ${
        isActive
          ? styles["navigation-tab--active"]
          : styles["navigation-tab--inactive"]
      }`}
    >
      {label}
    </Button>
  );
};
